// UserPhoto.js
import React from "react";
import PropTypes from "prop-types";

 

const isValidPhotoUrl = (url) => {
    if (!url || typeof url !== "string") return false;

    const trimmed = url.trim();
    // Validate extension first (case-insensitive)
    const hasValidExtension = /\.(jpg|JPG|png|PNG|jpeg)$/i.test(trimmed);
    if (!hasValidExtension) return false;

    // Validate that URL has http/https protocol and a host/domain
    try {
        const parsed = new URL(trimmed);
        const isHttp = parsed.protocol === "http:" || parsed.protocol === "https:";
        const hasHost = !!parsed.hostname;
        return isHttp && hasHost;
    } catch {
        // new URL throws if it's not an absolute URL with protocol/host
        return false;
    }
};

const UserPhoto = ({ photo, firstName, lastName, sharedFirstName, sharedLastName, customClass="" }) => {
  const getInitials = (name) => {
    if (!name) return "";
    const nameArray = name.split(" ");
    return nameArray.length > 1
      ? nameArray[0][0] + nameArray[1][0]
      : nameArray[0][0];
  };

  return (
    <div className={`avatar${customClass ? ` ${customClass}` : ""}`}>
      {photo && isValidPhotoUrl(photo) ? (
        <img src={photo} alt="User Avatar" />
      ) : (
                  <span>{getInitials(sharedFirstName && sharedLastName ? sharedFirstName + " " + sharedLastName : firstName + " " + lastName) || "U"}</span>
      )}
    </div>
  );
};

UserPhoto.propTypes = {
  photo: PropTypes.string,
  firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    sharedFirstName: PropTypes.string,
    sharedLastName: PropTypes.string,
    customClass: PropTypes.string,
};

export default UserPhoto;
